import { useUserEventLogger } from '@repo/tracking-service';
import { TopNavigation } from '@zenterprise-inc/ui';
import { useRouter } from 'next/router';
import { useCallback } from 'react';

import s from '@/components/my/common/layout.module.scss';
import { useChangePasswordContext } from '@/components/my/password/contexts/ChangePasswordProvider';

export const MyPasswordTopNavigation = () => {
  const { back } = useRouter();
  const { step, renderPrevPage } = useChangePasswordContext();
  const { sendClickEvent } = useUserEventLogger();

  const routingForStep = useCallback(() => {
    if (step === 'current-password') {
      sendClickEvent('pw-check_topnav_back');

      back();
    } else {
      sendClickEvent('pw-change_topnav_back');

      renderPrevPage();
    }
  }, [step, back, renderPrevPage, sendClickEvent]);

  return <TopNavigation.Basic leftIcon={'back'} onLeftClick={routingForStep} className={s.nav_position} />;
};
